export default __webpack_public_path__ + "static/media/Ballroll_00323.613ade62.png";